// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"60":"Bitacora","274":"Home","338":"Income","474":"VehicleDetail","681":"VehicleEdit","724":"VehiclesList"}[chunkId] || chunkId) + "." + {"60":"bfb78d0a","236":"2ba9017a","274":"95f3daba","338":"142880c4","474":"f2ec6f50","681":"f2ec6f50","724":"788801b4"}[chunkId] + ".css";
};